import React ,  {useEffect, useState}from 'react'
import { Button, Form ,TextArea, Dropdown, FormCheckbox} from 'semantic-ui-react';
import { Field, useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import {ADD_PUBLIC , PUBLIC_COMPLET } from '../../../../gql/publication';
//import Preview from '../../Publications/PreviewPublication./Preview';
//import "./Title.scss";
//import usePublic from '../../../hooks/usePublic';



export default function Promo (props) {
const  { publication , setShowModal } = props;

const [completPublic] = useMutation (PUBLIC_COMPLET);



console.log(publication)

console.log (publication._id)

const formik = useFormik ({
  initialValues:initialValue(),


  validationSchema:Yup.object({
    
    
    ofertPre:Yup.string().required(),



    /*Yup.object()shape({
      decimal: Yup.number().test(
        'is-decimal',
        'invalid decimal',
        value => (value + "").match(/^\d*\.{1}\d*$/),
      ),
    })*/

  }),


  onSubmit: async (formv) => {try
    { const formData= formv;
      console.log(formv);

       await completPublic({
        variables:{
          input:{
            idPublication:publication._id,
            title:publication.title,
            ofert:"Ofertas",
            ofertPre:formData.ofertPre,

          },
          },}
      );
      toast.success (" Promo en Proceso 😃 ");

      setTimeout(() =>  setShowModal (false),3000);


      
}    catch (error) {
      toast.error(error.message);
      console.log (error)
      console.log (formv)
    }
  },

 });





  return (
    
        <Form  onSubmit = {formik.handleSubmit} className= "mosset">
        <h2>
          El Articulo aparecera en la seccion de ofertas❗  
        </h2>
        

   <h2> Precio de la Oferta </h2>
          
<Form.Input type= "text" placeholder = "indica el precio"
           name= "ofertPre" value= {formik.values.ofertPre} 
           onChange = {formik.handleChange}
           error={formik.errors.ofertPre && true}


    />
              

      <Button type= "submit" className=' btn-submit'>  * Publicar * </Button> 

        </Form>
    
  )
}
function initialValue() {
  return  {
    "idPublication": "",
    "ofert":"oferta",
    "ofertPre": "",
    
  };
};
